<template>
  <div class="WidgetGroup_1">
    <TicketWidget v-for="e in ticketWidgetList"
      :key="e.id"
      :value="e"/>
  </div>
</template>

<style scoped>
    .WidgetGroup_1 {
        display: inline;
    }
</style>

<script>
export default {
    name : 'TicketWidgetGroup',

    props : ['group', 'ticketNo'],

    data() {
        return {
            ticketWidgetList : []
        }
    },

    mounted() {
        this.onGroupChange();
    },

    watch : {
        group() {
            this.onGroupChange();
        }
    },

    methods : {
        onGroupChange() {
            if ( !this.group ) {
                console.log('#39 onGroupChange', this.group, this.ticketNo, this);
                return;
            }

            if ( !this.ticketNo ) {
                this.listByGroupCached();
                return;
            }

            this.listByGroupAndTicketNoCached();
        },

        listByGroupAndTicketNoCached() {
            var _this = this;

            sdk.TicketWidgetApi().listByGroupAndTicketNoCached({
                group : _this.group,
                ticketNo : _this.ticketNo
            }).then(res => {
                _this.ticketWidgetList = res;
            });
        },

        listByGroupCached() {
            var _this = this;

            sdk.TicketWidgetApi().listByGroupCached({
                group : _this.group
            }).then(res => {
                _this.ticketWidgetList = res;
            });
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetGroup.vue